










import Vue from "vue";
import Component from "vue-class-component";
import { Inject } from "vue-property-decorator";
import { RestClient } from "@elite/restclient";
import { IDeleteButtonCellRendererParams } from "../table";

@Component
export default class GridDeleteButton extends Vue {
    @Inject()
    restClient!: RestClient;

    /**
     * Row parameter data
     * https://www.ag-grid.com/vue-data-grid/component-cell-renderer/#cell-renderer-component-3
     */
    params!: IDeleteButtonCellRendererParams;

    get id(): number {
        return this.params.value as number;
    }

    async deleteLineItem(): Promise<void> {
        if (!confirm("Are you sure you want to delete this item?")) {
            return;
        }

        const response = await this.restClient.delete(
            `${this.params.apiUrl}/${this.id}`
        );

        if (response.status === 200 && this.params.eventName) {
            this.$root.$emit(this.params.eventName);
        }
    }
}
